import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=dfab74d0"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports